<template>
  <div>
    <v-card class="mx-auto">
      <v-card-text class="pa-5 black--text">
        <v-row class="mx-2 my-3">
          <v-col cols="12" class="py-0">
            <div class="secondary--text" style="font-size: 20px">
              <strong>{{ subTitle }}</strong> Aksi Nyata
            </div>
          </v-col>
          <v-col cols="12">
            <base-form-generator :schema="schema" v-model="form" class="pt-2" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import RenderInstrumen from '../instrumen/RenderInstrumen';
import LokakaryaNyata from '../instrumen/LokakaryaNyata';

export default {
  mixins: [RenderInstrumen, LokakaryaNyata],
  components: { BaseFormGenerator },
  props: {
    subTitle: {
      type: String,
      default: '',
    },
    initValue: {
      type: Object,
      default: () => null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {},
    },
    meta: {
      type: Object,
      default: () => {},
    },
    kKegiatan: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {},
  methods: {
    initForm(value) {
      let result = {};
      for (const ins of value.instrumen || []) {
        const tipe = this.$getDeepObj(ins, 'm_lokakarya_instrumen_psp.tipe') || '';

        if (tipe === 'checkbox') {
          if (result[`instrumen-${tipe}-${ins.k_lokakarya_instrumen_psp}`]) {
            result[`instrumen-${tipe}-${ins.k_lokakarya_instrumen_psp}`].push(ins.k_lokakarya_opsi_psp);
          } else {
            result[`instrumen-${tipe}-${ins.k_lokakarya_instrumen_psp}`] = [ins.k_lokakarya_opsi_psp];
          }
        } else if (tipe === 'radio') {
          result[`instrumen-${tipe}-${ins.k_lokakarya_instrumen_psp}`] = ins.k_lokakarya_opsi_psp;
        } else {
          result[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] = ins.isian || '';
        }

        if (ins.isian) {
          this.$set(this.form, `input-lain-${ins.k_lokakarya_instrumen_psp}-${ins.k_lokakarya_opsi_psp}`, ins.isian);
        }
      }

      for (const rs in result) {
        this.$set(this.form, rs, result[rs]);
      }
    },

    reset() {
      this.$set(this, 'form', {});

      for (const ins of this.schema) {
        if (ins.type === 'Checkbox') {
          this.$set(this.form, ins.name, []);
        }
      }
    },

    getValue() {
      let form = Object.assign({}, this.form);

      const keysInstrumens = Object.keys(form).filter((key) => /instrumen/.test(key));
      for (const key of keysInstrumens) {
        const keys = key.split('-');
        const tipe = keys[1];
        const kLokakaryaInstrumen = keys[2];

        let result = [];
        if (tipe === 'checkbox') {
          result = (form[key] || []).map((value) => {
            return {
              k_lokakarya_instrumen_psp: kLokakaryaInstrumen,
              k_lokakarya_opsi_psp: value,
              isian: form[`input-lain-${kLokakaryaInstrumen}-${value}`] || '',
            };
          });
        } else if (tipe === 'radio') {
          result = [
            {
              k_lokakarya_instrumen_psp: kLokakaryaInstrumen,
              k_lokakarya_opsi_psp: form[key],
              isian: form[`input-lain-${kLokakaryaInstrumen}-${form[key]}`] || '',
            },
          ];

          delete form[`input-lain-${kLokakaryaInstrumen}-${form[key]}`];
        } else {
          result = [
            {
              k_lokakarya_instrumen_psp: kLokakaryaInstrumen,
              isian: form[key],
            },
          ];
        }

        if (form.instrumen) {
          form.instrumen = [...form.instrumen, ...result];
        } else {
          form.instrumen = result;
        }

        delete form[key];
      }

      return Object.assign({}, form);
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
